<template>
  <div
    :class="{ collapse: isCollapse }"
    class="side-cart-container"
  >
    <div
      :class="{ collapse: isCollapse }"
      class="collapse-box"
    >
      <img
        @click="handleCollapse"
        :class="{ rotate: !isCollapse }"
        class="collapse-icon"
        src="@/assets/images/icon-collapse.svg"
        alt=""
      >
    </div>
    <div
      v-show="isCollapse"
      class="collapse-content"
    >
      <div class="my-cart">
        <img
          src="@/assets/illus/illus-my-cart.svg"
          alt=""
          width="64px"
        >
        <div class="my-cart-text">
          My Cart
          <div
            v-if="cartStore.cartCount > 0"
            class="cart-count"
          >
            {{ cartStore.cartCount > 99 ? '99+' : cartStore.cartCount }}
          </div>
        </div>
      </div>
    </div>
    <div
      :style="{ display: isCollapse ? 'none' : 'block' }"
      class="expand-content"
    >
      <div class="header">
        <div class="sub-total">
          Subtotal
        </div>
        <div class="total-price">
          <IntlCurrency :currency="currency.current.targetCurrency" />
          {{ Number(total).toFixed(2) }}
        </div>
        <div
          @click="toCartPage"
          class="check-btn"
        >
          Checkout
        </div>
        <div
          @click="toCartPage"
          class="toCart-btn"
        >
          Go to cart
        </div>
      </div>
      <div
        class="split-line"
        style="margin-top: 12px; margin-bottom: 8px;"
      />
      <CartList
        v-if="user.isLogged"
        @total-change="handleTotalChange"
      />
      <div
        v-else
        class="empty-cart"
      >
        <img
          src="@/assets/order/empty-cart.svg"
          alt=""
        >
        <div class="empty-text">
          Your cart is empty.
        </div>
        <div
          @click="handleLogin"
          class="sign-text"
        >
          Hello,Sign In
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { gaAnalytics, buriedPointUtil } from '@/utils/utils'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/pinia/user'
import { useLoginModal } from '@/components/Login'
import { useCartStore } from '@/pinia/cart'
import { IntlCurrency } from '../NewIntlCurrency'
import { useCurrencyStore } from '@/pinia/currency'
import CartList from './CartList.vue'

const store = useStore()
const user = useUserStore()
const cartStore = useCartStore()
const currency = useCurrencyStore()

const { open: openLoginModal } = useLoginModal()

const router = useRouter()

const isCollapse = computed(() => !cartStore.expand)

const handleCollapse = () => {
  cartStore.toggleExpand()
}

const total = ref(0)

const handleTotalChange = (val) => {
  total.value = val
}

watch(() => user.isLogged, (isLogged) => {
  if (!isLogged) total.value = 0
})

const toCartPage = () => {
  buriedPointUtil({ eventId: 'PC202' })
  router.push('/carts')
}

const handleLogin = () => {
  gaAnalytics('p_sign_in_click', 'p_sign_in_click')
  buriedPointUtil({ eventId: 'PWH201' })
  store.commit('setPassiveLogin', 0)
  openLoginModal()
}

onMounted(async () => {
  buriedPointUtil({ eventId: 'PC502' })
})
</script>

<style lang='less' scoped>
.collapse {
  width: 80px !important;
}

.side-cart-container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 144px;
  background-color: white;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
  overflow: auto;
  z-index: 1100;
  transition: width 0.3s;

  &::-webkit-scrollbar {
    display: none;
  }

  .collapse-box {
    position: fixed;
    top: 0;
    right: 0;
    width: 144px;
    height: 32px;
    background-color: #F4F7FF;
    border-bottom: 1px solid #d3e1fd;
    z-index: 999;
    transition: width 0.3s;

    .collapse-icon {
      position: absolute;
      top: 8px;
      left: 16px;
      transition: transform 0.3s;

      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  .collapse-content {
    position: relative;
    height: 100vh;
    .my-cart {
      position: absolute;
      top: 50%;
      left: 4px;
      right: 4px;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .my-cart-text {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
        color: #232323;
        font-size: 11px;
        font-family: mon-600;
        .cart-count  {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background-color: #009de0;
          font-size: 10px;
          color: white;
        }
      }
    }
  }

  .expand-content {
    transition: opacity 0.3s;
    padding-top: 48px;
  }

  .header {
    width: 128px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .sub-total {
      color: #232323;
      font-size: 12px;
      font-family: mon-500;
      line-height: 18px;
    }
    .total-price {
      display: flex;
      align-items: center;
      font-family: mon-700;
      margin-top: 2px;
    }
    .check-btn, .toCart-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 32px;
      border-radius: 20px;
      background-color: #052784;
      color: white;
      font-size: 12px;
      font-family: mon-600;
      margin-top: 8px;
      cursor: pointer;
    }
    .toCart-btn {
      border: 1px solid #EBF1F5;
      color: #232323;
      background-color: white;
    }
  }
  .split-line {
    height: 1px;
    width: 128px;
    background-color: #ebf5f5;
    margin: 12px auto;
  }
  .tab-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .tab-item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      color: #5c5c5c;
      font-size: 12px;
      font-family: mon-500;
      cursor: pointer;

      &.active {
        background-color: #EFF4FD;
        color: #232323;

        &::after {
          content: '';
          top: 50%;
          transform: translateY(-50%);
          position: absolute;
          left: 0;
          width: 2px;
          height: 20px;
          background-color: #052784;
          border-radius: 0 2px 2px 0;
        }
      }
    }
  }
  .empty-cart {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-text {
      color: #232323;
      font-size: 11px;
      font-family: mon-500;
      line-height: 14px;
    }
    .sign-text {
      text-decoration: underline;
      margin-top: 4px;
      color: #009de0;
      font-size: 11px;
      font-family: mon-600;
      line-height: 14px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
